module.exports = __webpack_public_path__ + "static/media/menuHappy.cc824467.png";